import { render, staticRenderFns } from "./PublishedCampaignPreview.vue?vue&type=template&id=65f663b5&lang=pug"
import script from "./PublishedCampaignPreview.vue?vue&type=script&lang=js"
export * from "./PublishedCampaignPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports